import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./AspectRatio.module.css";

export default function AspectRatio({
  className = "",
  ratioMobile,
  ratioDesktop,
  backgroundColor = "none",
  children,
}) {
  return (
    <div
      className={classNames(styles.AspectRatio, className)}
      style={{
        "--ratio-mobile": `${ratioMobile * 100}%`,
        "--ratio-desktop": `${ratioDesktop * 100}%`,
        "--background-color": backgroundColor,
      }}
    >
      {children}
    </div>
  );
}

AspectRatio.propTypes = {
  className: PropTypes.string,
  ratioMobile: PropTypes.number.isRequired,
  ratioDesktop: PropTypes.number.isRequired,
  backgroundColor: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};
